import { WeatherLocation } from 'src/types/WeatherLocation'
import api from 'src/utils/api/core'

export async function getWeatherLocations(portUuid?: string): Promise<WeatherLocation[] | undefined> {
  const res = await api.get<{ data: WeatherLocation[] }>(`/weather-locations`, { params: { portUuid } })
  return res && res.data && res.data.data
}
